export { LastTrades } from "./lastTrades.ui";
export { LastTradesWidget } from "./lastTrades.widget";
